import React from "react";

const ASP_Forms = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Forms</h1>
      <p>This is the ASP Forms page content.</p>
    </div>
  );
};

export default ASP_Forms;
